import { Form, Col, Row} from 'react-bootstrap';
import {useEffect, useReducer, useState, useRef } from "react";

const DatatableSearchField = ({handleSearchText, searchFieldTitle, value, controlId}) => {
    const handleKeyPress = (e) => {
        //console.log("KEYPRESS");
        //console.log(e.nativeEvent);
        if(e.nativeEvent.code === 'Enter'){
            e.preventDefault();
        }
    }

    

  return (
    <Form.Group as={Row} controlId={controlId != null ? controlId + "form_searchText" : "form_searchText"} >
        <Col lg="auto" className="d-flex align-items-center">
            <Form.Label className="tableMutedText">Search:</Form.Label>
            <Form.Control className="ms-2 me-2" value={value} onChange={handleSearchText} title={searchFieldTitle} onKeyUp={handleKeyPress} onKeyDown={handleKeyPress}/>
        </Col>
    </Form.Group>
  )
}

export default DatatableSearchField;